import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import portfolioData from '../data/portfolioData';
import 開會 from '../assets/images/開會.png';

const Home = () => {
  const { t } = useTranslation();
  const featuredProjects = portfolioData.slice(0, 3);

  return (
    <>
      {/* 首頁橫幅 */}
      <section className="hero-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-center">
              <h1 className="display-3 text-white">凱撒數位科技</h1>
              <p className="lead text-white mb-4">專業的網站設計與開發服務，助您打造數位成功之路</p>
              <Link to="/contact" className="btn btn-primary btn-lg">
                {t('contact')}
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 關於我們 */}
      <section className="py-5">
        <div className="container">
          <h2 className="text-center mb-4">{t('aboutUs')}</h2>
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4">
              <img 
                src={開會} 
                alt="團隊討論" 
                className="img-fluid rounded shadow"
              />
            </div>
            <div className="col-lg-6">
              <h3>我們的故事</h3>
              <p>凱撒數位科技（CaesarTechStudio）成立於2023年，是由一群充滿熱情的科技專業人士共同創立的數位科技公司。我們的創辦團隊擁有豐富的軟體開發、用戶體驗設計和數位行銷經驗，致力於為企業提供全方位的數位解決方案。</p>
              <p>我們相信，科技應該為人類創造更美好的生活和工作體驗。因此，我們專注於開發易用、高效且具創新性的數位產品，幫助企業在數位時代保持競爭力。</p>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col-md-6 mb-4">
              <div className="card h-100 border-0 shadow">
                <div className="card-body p-4">
                  <h3 className="mb-4 text-primary">{t('ourMission')}</h3>
                  <p>{t('missionDesc')}</p>
                  <ul className="list-unstyled">
                    <li className="mb-2"><i className="fas fa-check-circle text-success mr-2"></i> 提供卓越的用戶體驗</li>
                    <li className="mb-2"><i className="fas fa-check-circle text-success mr-2"></i> 開發創新的數位解決方案</li>
                    <li className="mb-2"><i className="fas fa-check-circle text-success mr-2"></i> 協助企業實現數位轉型</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="card h-100 border-0 shadow">
                <div className="card-body p-4">
                  <h3 className="mb-4 text-primary">{t('ourVision')}</h3>
                  <p>{t('visionDesc')}</p>
                  <ul className="list-unstyled">
                    <li className="mb-2"><i className="fas fa-arrow-circle-right text-primary mr-2"></i> 成為數位創新的領導者</li>
                    <li className="mb-2"><i className="fas fa-arrow-circle-right text-primary mr-2"></i> 培養最優秀的科技人才</li>
                    <li className="mb-2"><i className="fas fa-arrow-circle-right text-primary mr-2"></i> 開發改變產業的數位產品</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 我們的服務 */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-4">{t('ourServices')}</h2>
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img 
                src={開會}
                alt="團隊討論" 
                className="img-fluid rounded shadow"
              />
            </div>
            <div className="col-lg-6">
              <p className="lead">我們提供全方位的數位服務，助您在數位時代保持競爭力</p>
              <div className="services-list">
                <div className="service-item">
                  <i className="fas fa-laptop-code"></i>
                  <div>
                    <h5>網站設計與開發</h5>
                    <p>打造美觀且功能強大的網站，提升用戶體驗和轉換率</p>
                  </div>
                </div>
                <div className="service-item">
                  <i className="fas fa-mobile-alt"></i>
                  <div>
                    <h5>行動應用程式開發</h5>
                    <p>開發跨平台行動應用，讓您的服務隨時隨地觸及客戶</p>
                  </div>
                </div>
                <div className="service-item">
                  <i className="fas fa-chart-line"></i>
                  <div>
                    <h5>數位行銷策略</h5>
                    <p>制定有效的數位行銷策略，提高品牌知名度和客戶轉換</p>
                  </div>
                </div>
                <div className="service-item">
                  <i className="fas fa-cogs"></i>
                  <div>
                    <h5>系統整合與企業解決方案</h5>
                    <p>整合現有系統，提升企業營運效率與數據管理能力</p>
                  </div>
                </div>
              </div>
              <Link to="/services" className="btn btn-outline-primary mt-3">
                {t('learnMore')}
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 作品集 */}
      <section className="py-5">
        <div className="container">
          <div className="section-title text-center mb-5">
            <h2>{t('recentWorks')}</h2>
            <p>我們的團隊致力於創造優質的數位體驗，以下是我們的精選作品</p>
          </div>

          <div className="row">
            {featuredProjects.map(project => (
              <div className="col-md-4 mb-4" key={project.id}>
                <div className="portfolio-item card">
                  <img src={project.image} className="card-img-top" alt={project.title} />
                  <div className="card-body">
                    <span className="card-category">{project.category}</span>
                    <h5 className="card-title">{project.title}</h5>
                    <p className="card-text">{project.description.substring(0, 100)}...</p>
                    <Link to="/portfolio" className="btn btn-outline-primary">
                      {t('viewMore')}
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-4">
            <Link to="/portfolio" className="btn btn-primary">
              查看更多作品
            </Link>
          </div>
        </div>
      </section>

      {/* 聯絡我們 CTA */}
      <section className="py-5 bg-primary text-white text-center">
        <div className="container">
          <h2 className="mb-4">準備好開始您的數位轉型之旅了嗎？</h2>
          <p className="lead mb-4">讓我們一起合作，為您的企業打造最佳的數位解決方案</p>
          <Link to="/contact" className="btn btn-light btn-lg">
            立即聯絡我們
          </Link>
        </div>
      </section>
    </>
  );
};

export default Home; 